// main.ts
//import './assets/app.css';
// import './core/auth-guard';
// import 'jodit/es2021/jodit.min.css';
import { navigate, startRouter } from './app/router';

async function start() {
  // Chỉ gọi startRouter(), router sẽ tự động load layout và điều hướng route khởi tạo 1 lần duy nhất
  startRouter();

  // Bắt sự kiện click chung trên sidebar nếu cần
  document.querySelector('#sidebar')?.addEventListener('click', (e) => {
    const target = (e.target as HTMLElement).closest('a');
    if (!target) return;

    const href = target.getAttribute('href');
    if (!href || href === '#' || href.startsWith('javascript:')) return;

    if (href.startsWith('/')) {
      e.preventDefault();
      navigate(href);
    }
  });
  
}

start();